<template>
  <div class="product-intro">
    <div class="banner">
      <h2>金票</h2>
      <div class="bottom-line"></div>
      <p>“金票”是由核心企业向供应商开具的体现交易双方基础合同之间债权债务关系的电子付款承诺函。基于供应商对核心企业的应收账款，通过与外部金融机构的合作为供应商提供保理融资、拆分转让、持有到期收款的全流程在线金融服务。</p>
    </div>
    <div class="product-advantages">
      <h2>产品优势</h2>
      <div class="four">
        <div>
          <img src="../assets/product_advantages_1.png" alt />
          <p>免抵押、免担保</p>
        </div>
        <div>
          <img src="../assets/product_advantages_2.png" alt />
          <p>快速放款</p>
        </div>
        <div>
          <img src="../assets/product_advantages_3.png" alt />
          <p>可拆分融资</p>
        </div>
        <div>
          <img src="../assets/product_advantages_4.png" alt />
          <p>融资成本低</p>
        </div>
      </div>
    </div>
    <div class="flow">
      <h2>业务流程</h2>
      <img src="../assets/product_flow.png" alt />
    </div>
    <div class="product-question">
      <h2>常见问题</h2>
      <ul class="question-list">
        <li>
          <div class="question">金票在不融资的情况下，是否可以进行流转或持有到期？</div>
          <div class="answer">可以进行流转或持有到期。</div>
        </li>
        <li>
          <div class="question">在持有到期的情况下，承诺付款日期到了后，我们就能收到货款吗？</div>
          <div class="answer">供应商签收金票后，如未进行流转及融资，则在承诺付款日期到期时，平台会通知承诺付款方付款。在承诺付款方付款后，款项将自动划转到供应商在平台绑定的银行账户。</div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style lang="less">
.product-intro {
  text-align: center;
  .banner {
    color: #fff;
    background: url(../assets/product_advantages_bg.png) center center/100% 500px;
    height: 500px;
    padding: 100px 30px 150px;
    h2 {
      font-weight: bold;
      font-size: 32px;
      padding: 0 16px;
      margin-bottom: 16px;
    }
    .bottom-line {
      width: 32px;
      height: 4px;
      background: rgba(255, 255, 255, 0.5);
      margin: 0 auto;
    }
    p {
      font-size: 26px;
      font-weight: 300;
      line-height: 1.7;
      text-align: left;
      margin-top: 20px;
    }
  }
  .product-advantages {
    margin-bottom: 70px;
    h2 {
      margin: 80px 0 50px;
      font-size: 42px;
      color: #000;
    }
    .four {
      & > div {
        width: 50%;
        display: inline-block;
        margin-bottom: 45px;
      }
      img {
        width: 245px;
        height: 245px;
      }
      p {
        font-size: 28px;
        color: #666666;
        margin-top: 22px;
      }
    }
  }
  .flow {
    padding: 54px 30px 70px;
    background: rgba(246, 246, 246, 0.75);
    h2 {
      margin-bottom: 54px;
      font-size: 42px;
      color: #000;
    }
    img {
      height: 144px;
    }
  }
  .product-question {
    padding: 80px 30px;
    h2 {
      margin-bottom: 40px;
      font-size: 42px;
      color: #000;
    }
    .question-list {
      li {
        text-align: left;
        padding: 40px 30px;
        background: rgba(248, 248, 248, 1);
        margin-top: 30px;
      }
      font-size: 26px;
      line-height: 1.6;
      .question {
        color: #333;
        background: url(../assets/icon_question.png) 0 6px no-repeat;
        background-size: 30px 30px;
        padding-left: 50px;
      }
      .answer {
        color: #808080;
        background: url(../assets/icon_answer.png) 0 6px no-repeat;
        background-size: 30px 30px;
        padding-left: 50px;
        margin-top: 30px;
      }
    }
  }
}
</style>
